"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Popover.scss");
var key_press_1 = require("../../../utils/key-press");
var Join_1 = require("../../../helpers/Functions/Join");
/**
 *
 * <style>
 * #Popover-container ul[class*="rsg--list-"]{margin:20px 0;padding:0;}
 * #Popover-container li[class*="rsg--li-"]{display:inline;border:1px solid #ccc;border-radius:12px;}
 * #Popover-container li[class*="rsg--li-"]{background:#d12127;padding:4px 8px;color:#fff;margin-right:16px;}
 * #Popover-container li[class*="rsg--li-"] p{display:inline;color:#fff;}
 * </style>
 * <ul style="">
 * <li style="">UX Approval - Pending</li>
 * <li style="">Approval - Pending</li>
 * </ul>
 *
 */
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover(props) {
        var _this = _super.call(this, props) || this;
        _this.setResize = function () {
            if (!_this.boxRef2.current) {
                return;
            }
            var currentBox = _this.boxRef2.current;
            var sc = currentBox.style;
            sc.removeProperty('left');
            sc.removeProperty('right');
            _this.setState({
                resize: window.innerWidth,
            });
        };
        _this.handleClickOutside = function (event) {
            var domNode = document.getElementById('popover-outer-' + _this.props.uniqueId);
            if (!(domNode === null || domNode === void 0 ? void 0 : domNode.contains(event.target))) {
                _this.hidePopover();
            }
        };
        _this.onFocus = function (e) {
            var _a, _b, _c, _d;
            // const domNode = document.getElementById('popover-outer-' + this.props.uniqueId);
            if (((_a = _this.triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                return;
            }
            var c = false;
            if (_this.tabElements) {
                _this.tabElements.forEach(function (item) {
                    if (item === e.target) {
                        item.focus();
                        _this.previousEl = item;
                        c = true;
                        return;
                    }
                });
                if (!c && e.target !== _this.boxRef && !((_b = _this.boxRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
                    if (_this.previousEl === _this.firstEl) {
                        (_c = _this.lastEl) === null || _c === void 0 ? void 0 : _c.focus();
                    }
                    else {
                        (_d = _this.firstEl) === null || _d === void 0 ? void 0 : _d.focus();
                    }
                }
            }
        };
        _this.KeyDownHandler = function (e) {
            if (key_press_1.KeyPress.escIsPressed(e)) {
                _this.hidePopover();
            }
            else {
                if (key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
                    e.preventDefault();
                    if (!_this.state.showState) {
                        _this.showPopover();
                    }
                    else {
                        _this.hidePopover();
                    }
                }
            }
        };
        _this.popoverKeyDown = function (e) {
            if (key_press_1.KeyPress.escIsPressed(e)) {
                _this.hidePopover();
            }
        };
        var _a = props.show, show = _a === void 0 ? false : _a;
        _this.state = {
            showState: show,
            resize: 0,
        };
        _this.boxRef = React.createRef();
        _this.boxRef2 = React.createRef();
        _this.triggerRef = React.createRef();
        _this.headingRef = React.createRef();
        _this.arrowRef = React.createRef();
        _this.tabElements = [];
        _this.firstEl = '';
        _this.lastEl = '';
        _this.previousEl = '';
        _this.isAutoAligned = false;
        _this.onClick = _this.onClick.bind(_this);
        _this.showPopover = _this.showPopover.bind(_this);
        _this.hidePopover = _this.hidePopover.bind(_this);
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.KeyDownHandler = _this.KeyDownHandler.bind(_this);
        _this.popoverKeyDown = _this.popoverKeyDown.bind(_this);
        _this.autoAlignPopover = _this.autoAlignPopover.bind(_this);
        return _this;
    }
    Popover.prototype.componentDidMount = function () {
        var _a, _b;
        document.addEventListener("click", this.handleClickOutside, true);
        window.addEventListener("resize", this.setResize);
        if (this.props.show) {
            document.addEventListener("focus", this.onFocus, true);
            this.tabElements = (_a = this.boxRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input, button, a, select, textarea, div[tabindex="0"], div[role="button"]:not([aria-hidden=true]), div[role="checkbox"]:not([aria-hidden=true]), div[role="radio"]:not([aria-hidden=true])');
            if (this.tabElements) {
                this.firstEl = this.tabElements[0];
                this.lastEl = this.tabElements[this.tabElements.length - 1];
            }
            this.autoAlignPopover();
            (_b = this.firstEl) === null || _b === void 0 ? void 0 : _b.focus();
        }
    };
    Popover.prototype.autoAlignPopover = function () {
        var _a = this.props.align, align = _a === void 0 ? 'left' : _a;
        if (!this.boxRef.current || !this.boxRef2.current || !this.arrowRef.current || !this.triggerRef.current) {
            return;
        }
        var currentBox2 = this.boxRef.current;
        var bounds2 = currentBox2.getBoundingClientRect();
        var currentBox = this.boxRef2.current;
        var bounds = currentBox.getBoundingClientRect();
        var currentArrow = this.arrowRef.current;
        var arrowBounds = currentArrow.getBoundingClientRect();
        var currentTrigger = this.triggerRef.current;
        var triggerBounds = currentTrigger.getBoundingClientRect();
        if (document.documentElement.clientWidth <= 320) {
            if (align === 'center') {
                currentArrow.style.left = triggerBounds.left + (triggerBounds.width / 2) + 'px';
            }
            else if (align === 'left') {
                var res = triggerBounds.left + (triggerBounds.width / 2);
                res = res - bounds2.left;
                currentArrow.style.left = res + 'px';
            }
            else if (align === 'right') {
                var ab = bounds.width - (triggerBounds.width / 2);
                currentArrow.style.left = ab + 'px';
            }
        }
        else {
            if (align === 'center') {
                var sc = currentArrow.style;
                sc.removeProperty('left');
                // currentArrow.style.left = triggerBounds.left + (triggerBounds.width/2) + 'px';
            }
            else if (align === 'left') {
                currentArrow.style.left = (triggerBounds.width / 2) + 'px';
            }
            else if (align === 'right') {
                var ab = bounds.width - (triggerBounds.width / 2);
                currentArrow.style.left = ab + 'px';
            }
        }
        // if it is the size of the screen
        var sidePadding = window.innerWidth > 600 ? 32 : 16;
        if (bounds.left < 0) {
            currentBox.style.left = 0 + 'px';
            currentArrow.style.left = (triggerBounds.width / 2) + 'px';
            this.isAutoAligned = true;
        }
        else if (bounds.right > document.documentElement.clientWidth) {
            currentBox.style.right = -20 + 'px';
            currentArrow.style.left = bounds.width - (triggerBounds.width / 2) - 20 + 'px';
        }
    };
    Popover.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        if (this.props.show !== undefined && prevProps.show !== this.props.show) {
            this.setState({
                showState: this.props.show,
            });
            return;
        }
        if (this.state.showState) {
            // getting tab Element
            document.addEventListener("focus", this.onFocus, true);
            this.tabElements = (_a = this.boxRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input, button, a, select, textarea, div[tabindex="0"], div[role="button"]:not([aria-hidden=true]), div[role="checkbox"]:not([aria-hidden=true]), div[role="radio"]:not([aria-hidden=true])');
            if (this.tabElements) {
                this.firstEl = this.tabElements[0];
                this.lastEl = this.tabElements[this.tabElements.length - 1];
            }
            if (!this.boxRef2.current || !this.triggerRef.current) {
                return;
            }
            var currentBox = this.boxRef2.current;
            var bounds = currentBox === null || currentBox === void 0 ? void 0 : currentBox.getBoundingClientRect();
            var triggerPoint = this.triggerRef.current;
            var trigBounds = triggerPoint.getBoundingClientRect();
            // autoscroll
            if (((_b = this.boxRef2) === null || _b === void 0 ? void 0 : _b.current) !== null && ((_d = (_c = this.boxRef2) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.scrollTo)) {
                var isVisible = bounds.top + bounds.height - 1 >= window.innerHeight;
                if (this.props.sizing && window.innerWidth <= 767) {
                }
                else {
                    if (isVisible) {
                        window.scrollTo({
                            top: window.pageYOffset + 5 + (bounds.top + bounds.height - window.innerHeight),
                            left: 0,
                            behavior: 'smooth',
                        });
                        setTimeout(function () {
                            var _a;
                            (_a = _this.firstEl) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 300);
                    }
                    else {
                        (_e = this.firstEl) === null || _e === void 0 ? void 0 : _e.focus();
                    }
                }
            }
            this.autoAlignPopover();
        }
        if (prevState.showState === true && this.state.showState === false) {
            this.triggerRef.current.focus();
        }
    };
    Popover.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.handleClickOutside, true);
        document.removeEventListener("focus", this.onFocus, true);
        window.removeEventListener("resize", this.setResize);
    };
    Popover.prototype.showPopover = function () {
        if (!this.boxRef2.current) {
            return;
        }
        var currentBox = this.boxRef2.current;
        var sc = currentBox.style;
        sc.removeProperty('left');
        sc.removeProperty('right');
        if (this.props.onOpen) {
            this.props.onOpen();
        }
        else {
            this.setState({
                showState: true,
            });
        }
    };
    Popover.prototype.hidePopover = function () {
        if (this.props.onClose) {
            this.props.onClose();
        }
        else {
            this.setState({
                showState: false,
            });
        }
    };
    Popover.prototype.onClick = function (e) {
        e.stopPropagation();
        if (this.state.showState) {
            this.hidePopover();
        }
        else {
            this.showPopover();
        }
    };
    Popover.prototype.render = function () {
        var _a = this.props, testId = _a.testId, uniqueId = _a.uniqueId, sizing = _a.sizing, smallPadding = _a.smallPadding, _b = _a.align, align = _b === void 0 ? 'left' : _b, showClose = _a.showClose, title = _a.title, ariaHidden = _a.ariaHidden, _c = _a.content, content = _c === void 0 ? "stuff" : _c, _d = _a.show, show = _d === void 0 ? false : _d, boxWidth = _a.boxWidth, children = _a.children, _e = _a.position, position = _e === void 0 ? "bottom" : _e, className = _a.className;
        var showState = this.state.showState;
        var styleObj;
        if (position === "top") {
            styleObj = {
                bottom: '25px',
            };
        }
        else {
            styleObj = {};
        }
        var sizingVal = sizing ? true : false;
        return (React.createElement("div", { className: "inline-block", style: { verticalAlign: "middle" }, "data-testid": testId },
            React.createElement("div", { className: Join_1.join(["outerContainer"]), "data-testid": testId, id: 'popover-outer-' + uniqueId },
                React.createElement("div", { ref: this.triggerRef, className: Join_1.join("rel", "trigger", styles.childContainer, className), onClick: this.onClick, onKeyDown: this.KeyDownHandler, "aria-expanded": showState ? true : false }, children),
                React.createElement("div", { ref: this.boxRef, onKeyDown: this.popoverKeyDown, className: Join_1.join(align === 'right' ? styles.popoverWrapperRight : styles.popoverWrapper, "text-left", align === 'right' ? 'flex justify-end' : align === 'center' ? 'flex justify-center' : '') },
                    React.createElement("div", { ref: this.boxRef2, id: uniqueId + '-popoverBox', className: Join_1.join(styles.popover, "absolute mar-t-xxs bg-white border border-gray-300 pad-sm-all opacity0 text-left fadein", smallPadding ? 'pad-xs-lg' : '', showState ? styles.z1 : "fadeout " + styles.zOne, showState && sizingVal ? styles.popoverFull : ''), style: __assign({ width: boxWidth + 'px' }, styleObj), tabIndex: showState ? 0 : -1, "aria-hidden": false },
                        position === "top" ? React.createElement("div", { ref: this.arrowRef, className: Join_1.join("arrow", showState && styles.show, styles.arrow, styles.arrowBottom, showState && sizingVal ? styles.arrowshowFull : '') }) : null,
                        showState ?
                            React.createElement(React.Fragment, null,
                                React.createElement("h3", { tabIndex: 0, ref: this.headingRef, className: [
                                        styles.popoverHeading,
                                        'heading-md mar-b-xs',
                                    ].join(' ') }, title),
                                content,
                                React.createElement("button", { onClick: this.hidePopover, name: "close", className: [
                                        styles.closeButton,
                                        "flex absolute",
                                        showClose ? '' : styles.closeHide,
                                        sizingVal ? styles.closeButtonFull : '',
                                    ].join(" "), "aria-label": "Close popup" },
                                    React.createElement("span", { className: "flex icon-close height-md-all width-md-all" }))) : null,
                        position === "bottom" ? React.createElement("div", { ref: this.arrowRef, className: Join_1.join("arrow", showState && styles.show, styles.arrow, styles.arrowTop, showState && sizingVal ? styles.arrowshowFull : '') }) : null)))));
    };
    return Popover;
}(React.Component));
exports.default = Popover;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Popover/Popover.js
// module id = 1798
// module chunks = 8